import TopicTwo from "../../resource-contents/born-to-trade-podcast-contents/TopicTwo";

const BornToTradePodcastContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__resource">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>The Perfect Companion to Your Trading Journey</h1>
            <p>Where experience meets education.</p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Diverse Market Coverage</h4>
                </div>
                <p>
                  From global indices to emerging digital assets, every episode
                  explores multiple markets to give you a 360° trading
                  perspective.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Real Stories. Real Traders</h4>
                </div>
                <p>
                  Learn from personal journeys of traders who’ve faced market
                  volatility, navigated risk, and achieved consistency.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Insights That Evolve With You</h4>
                </div>
                <p>
                  Designed to grow alongside your trading journey, from your
                  first trade to advanced portfolio management.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BornToTradePodcastContentFive;
